export default __webpack_public_path__ + "static/media/scoreimg.6b1e9a86.png";